import React, { useState, useEffect } from 'react';
import { attendanceAPI, studentsAPI } from '../../services/api';
import DataTable from '../../components/common/DataTable';
import StatusBadge from '../../components/common/StatusBadge';
import toast from 'react-hot-toast';
import { formatDate } from '../../utils/helpers';
import './attendance.scss';
import StudentsAttendanceHistory from './StudentsAttendanceHistory';
import StaffAttendanceHistory from './StaffAttendanceHistory';
import LeaveRequests from './LeaveRequests';

const staffList = [
  {id:11, rfid:321, StaffName: "John", Mobile:9876543210, depmt: "Teaching", desgntn: "Math teacher", CheckIn: "09:00 AM", CheckOut: "04:00 PM", Status:"pending" },
  {id:11, rfid:321, StaffName: "Leesa", Mobile:9876543210, depmt: "Teaching", desgntn: "Math teacher", CheckIn: "09:00 AM", CheckOut: "04:00 PM", Status:"pending" },
  {id:11, rfid:321, StaffName: "Syam", Mobile:9876543210, depmt: "Teaching", desgntn: "Math teacher", CheckIn: "09:00 AM", CheckOut: "04:00 PM", Status:"pending" },
  {id:11, rfid:321, StaffName: "Nikolace", Mobile:9876543210, depmt: "Teaching", desgntn: "Math teacher", CheckIn: "09:00 AM", CheckOut: "04:00 PM" },
]



const AttendanceManagement = () => {
  const [tab, setTab] = useState('mark');
  const [attendanceDate, setAttendanceDate] = useState(new Date().toISOString().split('T')[0]);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [students, setStudents] = useState([]);
  const [staffAttend, setStaffAttend] = useState(staffList);
  const [attendance, setAttendance] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [history, setHistory] = useState([]);
  const [todaySummary, setTodaySummary] = useState({});
  const [department, setDepartment] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [tabAttendance, setTabAttendance] = useState("daily-attendance");

  useEffect(() => {
    studentsAPI.classes().then(r => setClasses(r.data.results || r.data)).catch(() => { });
    attendanceAPI.todaySummary().then(r => setTodaySummary(r.data)).catch(() => { });
  }, []);

  useEffect(() => {
    if (selectedClass) {
      studentsAPI.sections({ class_obj: selectedClass }).then(r => setSections(r.data.results || r.data)).catch(() => { });
    }
  }, [selectedClass]);

  const loadStudents = async () => {
    if (!selectedClass) return toast.error('Please select a class');
    setLoading(true);
    try {
      const params = { current_class: selectedClass, status: 'active', page_size: 100 };
      if (selectedSection) params.current_section = selectedSection;
      const res = await studentsAPI.list(params);
      const studentList = res.data.results || res.data;
      setStudents(studentList);
      const initialAtt = {};
      studentList.forEach(s => { initialAtt[s.id] = 'present'; });
      setAttendance(initialAtt);
    } catch { toast.error('Failed to load students'); }
    finally { setLoading(false); }
  };

  const handleSave = async () => {
    if (!students.length) return toast.error('Load students first');
    setSaving(true);
    try {
      const promises = students.map(s =>
        attendanceAPI.markStudentAttendance({
          student: s.id, section: s.current_section,
          date: attendanceDate, status: attendance[s.id] || 'present',
        }).catch(() => { })
      );
      await Promise.all(promises);
      toast.success('Attendance marked successfully!');
    } catch { toast.error('Some records may have failed'); }
    finally { setSaving(false); }
  };

  const markAll = (status) => {
    const updated = {};
    students.forEach(s => { updated[s.id] = status; });
    setAttendance(updated);
  };

  const handleAttendance = (studentId, status) => {
    setAttendance((pre) => ({
      ...pre, [studentId]: status
    }))
  }

  const handleSelectAll = (status) => {
    const updated = {};
    studentsDairy.forEach((student) => {
      updated[student.id] = status
    })
    setAttendance(updated)
  }



  const studentsDairy = [
    {
      id: 1,
      subject: "English",
      start: "14:10",
      end: "14:30",
      name: "Akhil Reddy",
      roll: "CBSE_1A_012",
      activity: "Reading",
    },
    {
      id: 2,
      subject: "English",
      start: "14:10",
      end: "14:30",
      name: "Vasavi Rao",
      roll: "CBSE_1A_003",
      activity: "Writing",
    },
    {
      id: 3,
      subject: "English",
      start: "14:10",
      end: "14:30",
      name: "Amar Kumar",
      roll: "CBSE_1A_013",
      activity: "Grammar",
    },
    {
      id: 4,
      subject: "English",
      start: "14:10",
      end: "14:30",
      name: "Arvind Reddy",
      roll: "CBSE_1A_004",
      activity: "Homework",
    },
  ];

  const staffAttendance = [
    { department: "Accounts", designation: "Accountents" },
    { department: "Teaching", designation: "Teacher" },
    { department: "Library", designation: "Librarians" },
  ]



  return (
    <div>
      {/* <div className="page-header">
        <div><h2>Attendance Management</h2>
          <p>Mark and track student attendance</p>
        </div>
      </div>      */}

      <div className="d-flex gap-2 mb-4">
        {[['mark', '✏️ Students Attendance'], ['staff', '✏️ Staff Attendance'], ['dairy', '✏️ Digital Dairy'], ['history', '📋 Students History'], ['staffHistory', '📋Staff History'], ['leaves', '🏖️ Leave Requests']].map(([k, l]) => (
          <button key={k} className={`btn ${tab === k ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab(k)}>{l}</button>
        ))}
      </div>

      {tab === 'mark' && (
        <div className="card">
          <div className="card-header inline">
            <div className='d-flex gap-3'>
              Students Attendance
              {/* <button className={`btn ${tabAttendance ? "btn-primary" : "btn-outline-primary"}`} onClick={()=> setTabAttendance("daily-attenance")}> Daily Attendance</button>
              <button className='btn btn-primary'> Add Manual Attendance</button> */}
            </div>
            <div className="d-flex font-12 gap-3">
              {[
                // icon: '✅', icon: '❌',
                { label: "Today's Present", value: todaySummary.present || 0, color: 'green' },
                { label: "Today's Absent", value: todaySummary.absent || 0, background: 'red' },
              ].map(s => (
                <div key={s.label} className="">
                  <div className="stat-card p-1">
                    <span style={{ background: s.color === 'green' ? '#f0fdf4' : '#fef2f2', color: s.color === 'green' ? '#15803d' : '#b91c1c' }}>{s.icon}</span>
                    <span ><span className=''>{s.value}</span> <span>{s.label}</span></span>
                  </div>
                </div>
              ))}
            </div>

          </div>
          <div className="card-body">
            <div className="row g-2 mb-4">
              <div className="col-md-2">
                <label className="form-label">Date</label>
                <input type="date" className="form-control" value={attendanceDate} onChange={e => setAttendanceDate(e.target.value)} />
              </div>
              <div className="col-md-2">
                <label className="form-label">Curriculum</label>
                <select className="form-select" value={selectedClass} onChange={e => setSelectedClass(e.target.value)}>
                  <option value="">Select Curriculum</option>
                  <option value="">SSC</option>
                  <option value="">CBSC</option>
                  {/* {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)} */}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Class</label>
                <select className="form-select" value={selectedClass} onChange={e => setSelectedClass(e.target.value)}>
                  <option value="">Select Class</option>
                  {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Section</label>
                <select className="form-select" value={selectedSection} onChange={e => setSelectedSection(e.target.value)}>
                  <option value="">All Sections</option>
                  {sections.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
              </div>
              <div className="col-md-2 d-flex align-items-end">
                <button className="btn btn-primary w-100" onClick={loadStudents} disabled={loading}>
                  {loading ? <span className="spinner-border spinner-border-sm" /> : '🔍 Load Students'}
                </button>
              </div>
            </div>

            {students.length > 0 && (
              <>
                <div className="d-flex gap-2 mb-3">
                  <button className="btn btn-sm btn-outline-success" onClick={() => markAll('present')}>✅ Mark All Present</button>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => markAll('absent')}>❌ Mark All Absent</button>
                  <button className="btn btn-sm btn-outline-info">Send Absent Notifications</button>
                  <span className="ms-auto text-muted" style={{ fontSize: 13 }}><b className="text-info">{students.length}</b> students</span>
                </div>
                <div className="table-responsive border">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>RFID</th>
                        <th>Adm No.</th>
                        <th>Student Name</th>
                        <th>Roll No.</th>
                        <th>Mobile</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Check-In</th>
                        <th>Check-Out</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {students.map((s, i) => (
                        <tr key={s.id} style={{ background: attendance[s.id] === 'absent' ? '#fff5f5' : attendance[s.id] === 'late' ? '#fffbeb' : 'transparent' }}>
                          <td>{i + 1}</td>
                          <td>123</td>
                          <td><code style={{ fontSize: 12 }}>{s.admission_number}</code></td>
                          <td><strong>{s.full_name || `${s.first_name} ${s.last_name}`}</strong></td>
                          <td>{s.roll_number || '—'}</td>
                          <td>976431221</td>
                          <td>1 class</td>
                          <td>Vayu</td>
                          <td>09:00 AM</td>
                          <td>04:00 PM</td>
                          <td>
                            <div className="d-flex gap-2">
                              {['present', 'absent', 'late', 'excused'].map(status => (
                                <button
                                  key={status}
                                  type="button"
                                  className={`btn btn-sm ${attendance[s.id] === status ? 'btn-' + (status === 'present' ? 'success' : status === 'absent' ? 'danger' : 'warning') : 'btn-outline-secondary'}`}
                                  style={{ fontSize: 11, padding: '3px 10px' }}
                                  onClick={() => setAttendance(a => ({ ...a, [s.id]: status }))}
                                >
                                  {status.charAt(0).toUpperCase() + status.slice(1)}
                                </button>
                              ))}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between mt-3">
                  <span className="d-flex">
                    <button className='btn btn-outline-warning'> Export to Excel </button>
                    <ul class="pagination mb-0 ms-3">
                      <li class="page-item disabled"><a class="page-link" href="#">Previous</a></li>
                      <li class="page-item"><a class="page-link" href="#">1</a></li>
                      <li class="page-item"><a class="page-link" href="#">2</a></li>
                      <li class="page-item"><a class="page-link" href="#">3</a></li>
                      <li class="page-item"><a class="page-link" href="#">Next</a></li>
                    </ul>
                  </span>

                  <button className="btn btn-primary btn-lg" onClick={handleSave} disabled={saving}>
                    {saving ? <><span className="spinner-border spinner-border-sm me-2" />Saving...</> : '💾 Save Attendance'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {tab === 'staff' && (
        <div className="card">
          <div className="card-header"><span>Staff Attendance </span></div>
          <div className="card-body">
            <div className="row g-2 mb-4">
              <div className="col-md-3">
                <label className="form-label">Date</label>
                <input type="date" className="form-control" value={attendanceDate} onChange={e => setAttendanceDate(e.target.value)} />
              </div>
              <div className="col-md-3">
                <label className="form-label">Department</label>
                {/* <select className="form-select" value={department} onChange={e => setDepartment(e.target.value)}>
                  <option value="">Select Class</option>
                  {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select> */}
                <select
                  className="form-select"
                  value={department}
                  onChange={(e) => setDepartment(e.target.value)}
                >
                  <option value="">Select Department</option>
                  {staffAttendance.map((c, index) => (
                    <option key={index} value={c.department}>
                      {c.department}
                    </option>
                  ))}
                </select>

              </div>
              <div className="col-md-3">
                <label className="form-label">Designation</label>
                {/* <select className="form-select" value={selectedSection} onChange={e => setSelectedSection(e.target.value)}>
                  <option value="">All Sections</option>
                  {sections.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select> */}
                <select className="form-select" value={department} onChange={(e) => setDepartment(e.target.value)}>
                  <option value="">Select Description</option>
                  {staffAttendance.map((des, inx) => (
                    <option key={inx} value={des.designation}>
                      {des.designation}
                    </option>
                  ))

                  }

                </select>
              </div>
              <div className="col-md-3 d-flex align-items-end">
                <button className="btn btn-primary w-100" onClick={loadStudents} disabled={loading}>
                  {loading ? <span className="spinner-border spinner-border-sm" /> : '🔍 Load Staff'}
                </button>
              </div>
            </div>

            {students.length > 0 && (
              <>
                <div className="d-flex gap-2 mb-3">
                  <button className="btn btn-sm btn-outline-success" onClick={() => markAll('present')}>✅ Mark All Present</button>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => markAll('absent')}>❌ Mark All Absent</button>
                  {/* <button className="btn btn-sm btn-outline-info">Send Absent Notifications</button> */}
                  <span className="ms-auto text-muted" style={{ fontSize: 13 }}><b className="text-info">{staffAttend.length}</b> Staff</span>
                </div>
                <div className="table-responsive border">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>RFID</th>
                        {/* <th>Adm No.</th> */}
                        <th>Staff Name</th>
                        <th>Mobile</th>
                        <th>Department</th>
                        <th>Designation</th>
                        <th>Check-In</th>
                        <th>Check-Out</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {staffList.map((stf, i) => (
                        <tr key={stf.id} style={{ background: attendance[stf.id] === 'absent' ? '#fff5f5' : attendance[stf.id] === 'late' ? '#fffbeb' : 'transparent' }}>
                          <td>{i + 1}</td>
                          <td>{stf.rfid}</td>
                          {/* <td><code style={{ fontSize: 12 }}>{s.admission_number}</code></td> */}
                          <td><strong>{stf.StaffName}</strong></td>
                          {/* <td>{s.roll_number || '—'}</td> */}
                          <td>{stf.Mobile}</td>
                          <td>{stf.depmt}</td>
                          <td>{stf.desgntn}</td>
                          <td>{stf.CheckIn}</td>
                          <td>{stf.CheckOut}</td>
                          <td>
                            <div className="d-flex gap-2">
                              {['present', 'absent', 'late', 'excused'].map(status => (
                                <button
                                  key={status}
                                  type="button"
                                  className={`btn btn-sm ${attendance[stf.id] === status ? 'btn-' + (status === 'present' ? 'success' : status === 'absent' ? 'danger' : 'warning') : 'btn-outline-secondary'}`}
                                  style={{ fontSize: 11, padding: '3px 10px' }}
                                  onClick={() => setAttendance(a => ({ ...a, [stf.id]: status }))}
                                >
                                  {status.charAt(0).toUpperCase() + status.slice(1)}
                                </button>
                              ))}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between mt-3">
                  <span className="d-flex">
                    <button className='btn btn-outline-warning'> Export to Excel </button>
                    <ul class="pagination mb-0 ms-3">
                      <li class="page-item disabled"><a class="page-link" href="#">Previous</a></li>
                      <li class="page-item"><a class="page-link" href="#">1</a></li>
                      <li class="page-item"><a class="page-link" href="#">2</a></li>
                      <li class="page-item"><a class="page-link" href="#">3</a></li>
                      <li class="page-item"><a class="page-link" href="#">Next</a></li>
                    </ul>
                  </span>

                  <button className="btn btn-primary btn-lg" onClick={handleSave} disabled={saving}>
                    {saving ? <><span className="spinner-border spinner-border-sm me-2" />Saving...</> : '💾 Save Attendance'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {tab === 'dairy' && (
        <div className="card">
          <div className="card-body">
            <div className="student-diary-page">
              {/* TOP SECTION */}
              <div className="top-card">
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                  <div className="d-flex gap-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="diary"
                        defaultChecked
                      />
                      <label className="form-check-label">
                        Student Diary
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="diary"
                      />
                      <label className="form-check-label">
                        Staff Diary
                      </label>
                    </div>
                  </div>

                  <button
                    className="btn activity-btn"
                    onClick={() => setShowModal(true)}
                  >
                    <i className="bi bi-plus-lg"></i>
                    Add Activity
                  </button>
                </div>

                {/* FILTERS */}
                <div className="row g-3 mt-3">
                  <div className="col-xl-2 col-lg-3 col-md-4">
                    <label>Date</label>

                    <div className="input-icon">
                      <input type="date" className="form-control" />
                      {/* <i className="bi bi-calendar3 icon"></i> */}
                    </div>
                  </div>

                  <div className="col-xl-2 col-lg-3 col-md-4">
                    <label>Curriculum Code</label>

                    <select className="form-select">
                      <option>2017-18-CBSE-English</option>
                    </select>
                  </div>

                  <div className="col-xl-2 col-lg-3 col-md-4">
                    <label>Class</label>

                    <select className="form-select">
                      <option>One</option>
                    </select>
                  </div>

                  <div className="col-xl-2 col-lg-3 col-md-4">
                    <label>Section</label>

                    <select className="form-select">
                      <option>CBSE_1A</option>
                    </select>
                  </div>

                  <div className="col-xl-2 col-lg-3 col-md-4">
                    <label>Subject</label>

                    <select className="form-select">
                      <option>English</option>
                    </select>
                  </div>

                  <div className="col-xl-2 col-lg-3 col-md-4">
                    <label>Search</label>

                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                      />

                      <i className="bi bi-search search-icon"></i>
                    </div>
                  </div>
                </div>
              </div>

              {/* TABLE */}
              <div className="table-card mt-4">
                <div className="table-responsive">
                  <table className="table custom-table align-middle">
                    <thead>
                      <tr>
                        <th>Subject</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Student Name</th>
                        <th>Roll No</th>
                        <th className="text-center">
                          <div className="d-flex flex-column align-items-center gap-1">
                            <span>Present</span>
                            <label className="attendance-radio present-radio">
                              <input
                                type="radio"
                                name="select-all"
                                onChange={() => handleSelectAll('present')}
                              />
                              <span></span>
                            </label>

                          </div>
                        </th>

                        <th className="text-center">
                          <div className="d-flex flex-column align-items-center gap-1">
                            <span>
                              Absent
                            </span>
                            <label className="attendance-radio absent-radio">
                              <input
                                type="radio"
                                name="select-all"
                                onChange={() => handleSelectAll('absent')}
                              />
                              <span></span>
                            </label>
                          </div>
                        </th>

                        <th className="text-center">
                          <div className="d-flex flex-column align-items-center gap-1">
                            <span>Tardy</span>
                            <label className="attendance-radio tardy-radio">
                              <input
                                type="radio"
                                name="select-all"
                                onChange={() => handleSelectAll('tardy')}
                              />
                              <span></span>
                            </label>
                          </div>
                        </th>
                        <th>Activity</th>
                        <th>Homework</th>
                        <th>View</th>
                      </tr>
                    </thead>

                    <tbody>
                      {studentsDairy.map((student) => (
                        <tr key={student.id}>
                          <td>{student.subject}</td>
                          <td>{student.start}</td>
                          <td>{student.end}</td>
                          <td>{student.name}</td>
                          <td>{student.roll}</td>

                          {/* PRESENT */}
                          {/* <td>
                            <label className="attendance-radio">
                              <input
                                type="radio"
                                name={`attendance-${student.id}`}
                              />
                              <span></span>
                            </label>
                          </td> */}

                          <td className="text-center">

                            <label className="attendance-radio present-radio">

                              <input
                                type="radio"
                                name={`attendance-${student.id}`}
                                checked={attendance[student.id] === 'present'}
                                onChange={() =>
                                  handleAttendance(student.id, 'present')
                                }
                              />

                              <span></span>

                            </label>

                          </td>

                          {/* ABSENT */}
                          {/* <td>
                            <label className="attendance-radio">
                              <input
                                type="radio"
                                name={`attendance-${student.id}`}
                              />
                              <span></span>
                            </label>
                          </td> */}

                          <td className="text-center">

                            <label className="attendance-radio absent-radio">

                              <input
                                type="radio"
                                name={`attendance-${student.id}`}
                                checked={attendance[student.id] === 'absent'}
                                onChange={() =>
                                  handleAttendance(student.id, 'absent')
                                }
                              />

                              <span></span>

                            </label>

                          </td>

                          {/* TARDY */}
                          {/* <td>
                            <label className="attendance-radio">
                              <input
                                type="radio"
                                name={`attendance-${student.id}`}
                              />
                              <span></span>
                            </label>
                          </td> */}

                          <td className="text-center">

                            <label className="attendance-radio tardy-radio">

                              <input
                                type="radio"
                                name={`attendance-${student.id}`}
                                checked={attendance[student.id] === 'tardy'}
                                onChange={() =>
                                  handleAttendance(student.id, 'tardy')
                                }
                              />

                              <span></span>

                            </label>

                          </td>

                          {/* ACTIVITY */}
                          <td>
                            <span className="activity-badge">
                              {student.activity}
                            </span>
                          </td>

                          {/* HOMEWORK */}
                          <td>
                            <button className="btn hw-btn">
                              <i className="bi bi-journal-bookmark-fill"></i>
                            </button>
                          </td>

                          {/* VIEW */}
                          <td>
                            <button className="btn view-btn">
                              <i className="bi bi-eye"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* MODAL */}
              {showModal && (
                <>
                  <div
                    className="custom-backdrop"
                    onClick={() => setShowModal(false)}
                  ></div>

                  <div className="custom-modal">
                    <div className="modal-box">
                      {/* HEADER */}
                      <div className="modal-header-custom">
                        <h4>Add Activity</h4>

                        <button
                          className="close-btn"
                          onClick={() => setShowModal(false)}
                        >
                          <i className="bi bi-x-lg"></i>
                        </button>
                      </div>

                      {/* BODY */}
                      <div className="modal-body-custom">
                        <div className="row g-3">
                          <div className="col-md-6">
                            <label>Activity Title</label>

                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter title"
                            />
                          </div>

                          <div className="col-md-6">
                            <label>Activity Type</label>

                            <select className="form-select">
                              <option>Class Work</option>
                              <option>Homework</option>
                              <option>Assignment</option>
                            </select>
                          </div>

                          <div className="col-md-6">
                            <label>Start Date</label>

                            <input
                              type="date"
                              className="form-control"
                            />
                          </div>

                          <div className="col-md-6">
                            <label>Due Date</label>

                            <input
                              type="date"
                              className="form-control"
                            />
                          </div>

                          <div className="col-12">
                            <label>Description</label>

                            <textarea
                              rows="4"
                              className="form-control"
                              placeholder="Write activity details..."
                            ></textarea>
                          </div>
                        </div>
                      </div>

                      {/* FOOTER */}
                      <div className="modal-footer-custom">
                        <button
                          className="btn cancel-btn"
                          onClick={() => setShowModal(false)}
                        >
                          Cancel
                        </button>

                        <button className="btn save-btn">
                          <i className="bi bi-check2-circle"></i>
                          Save Activity
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {tab === 'history' && (
        // <div className="card">
        //   <div className="card-header"><span>📋 Students History</span></div>
        //   <div className="">
        //     <div style={{ fontSize: 40, marginBottom: 12 }}>📊</div>
        //     <p>Select filters to view attendance history</p>
        //   </div>
        // </div>
            <StudentsAttendanceHistory/>
      )}

      {tab === 'staffHistory' && (
        // <div className="card">
        //   <div className="card-header"><span>📋 Staff History</span></div>
        //   <div className="card-body text-center text-muted py-5">
        //     <div style={{ fontSize: 40, marginBottom: 12 }}>📊</div>
        //     <p>Select filters to view attendance history</p>
        //   </div>
        // </div>
        <StaffAttendanceHistory/>
      )}

      {tab === 'leaves' && (
        <div className="card">
          {/* <div className="card-header">
            <span>🏖️ Leave Requests</span>
            <button className="btn btn-sm btn-primary">➕ New Request</button>
          </div> */}
          <div className=" ">
            <LeaveRequests/>
          </div>
          {/* <div className="card-body text-center text-muted py-5">
            <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
            <p>No leave requests pending</p>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default AttendanceManagement;
